import angular from 'angular';
import moment from 'moment';
import { GeracaoDeMarcacoesPadraoService } from '../geracao-de-marcacoes-padrao.service';
import { VisualizacaoPreviaGeracaoModalService } from '../modals/visualizacao-previa-geracao/visualizacao-previa-geracao.modal.service';
import {
    IGeracaoDeMarcacoesPadraoCreate,
    IGeracaoDeMarcacoesPadraoPreview
} from '../models/geracao-de-marcacoes-padrao.service.model';
import { IGeracaoDeMarcacoesPadraoForm } from './models/geracao-de-marcacoes-padrao.form.model';
import {
    IVisualizacaoPreviaGeracaoModalData,
    IVisualizacaoPreviaGeracaoModalTrabalhadorSelecionado
} from '../modals/visualizacao-previa-geracao/models/visualizacao-previa-geracao.modal.model';

export class GeracaoDeMarcacoesPadraoNewController {

    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        'GeracaoDeMarcacoesPadraoService',
        'VisualizacaoPreviaGeracaoModalService',
        'NewToaster',
    ];

    public form: angular.IFormController;
    public entity: IGeracaoDeMarcacoesPadraoForm = {} as IGeracaoDeMarcacoesPadraoForm;
    public busy = false;

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissao: (arg: string) => boolean,
            liberadoTela: (arg: string) => boolean,
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public GeracaoDeMarcacoesPadraoService: GeracaoDeMarcacoesPadraoService,
        public VisualizacaoPreviaGeracaoModalService: VisualizacaoPreviaGeracaoModalService,
        public NewToaster: { pop: (opts: { type: string; title: string; body?: string }) => void },
    ) {
        $scope.$on('ponto_apuracoesponto_preview_importacao_marcacoes_padrao_preview_loaded', (_event, _preview: IGeracaoDeMarcacoesPadraoPreview) => {
            this.busy = false;
            const modal = this.VisualizacaoPreviaGeracaoModalService.open(this.buildPreviewModalData());

            modal.result
                .then((confirmado) => {
                    if (!confirmado) {
                        return;
                    }

                    this.busy = true;
                    this.GeracaoDeMarcacoesPadraoService.gerar(this.entity.apuracaoponto, this.setRequestBody());
                })
                .catch(() => { /* modal cancelada */ });
        });

        $scope.$on('ponto_apuracoesponto_preview_importacao_marcacoes_padrao_preview_error', (_event, error) => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
				title: 'Ocorreu um erro ao carregar a visualização da prévia.',
                body: this.getErrorMessage(error),
            });
        });

        $scope.$on('ponto_apuracoesponto_gerar_importacao_marcacoes_padrao_loaded', () => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'success',
                title: 'Geração de marcações padrão iniciada com sucesso.'
            });
            this.$state.go('geracaodemarcacoespadrao');
        });

        $scope.$on('ponto_apuracoesponto_gerar_importacao_marcacoes_padrao_error', (_event, error) => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro ao confirmar a geração.',
                body: this.getErrorMessage(error),
            });
        });
    }

    submit() {
        this.form.$submitted = true;

        if (this.form.$invalid) {
            return;
        }

        if (this.isSelecaoPorTrabalhadorSemItens()) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Selecione ao menos um trabalhador para visualizar a prévia.',
            });
            return;
        }

        this.busy = true;
        this.GeracaoDeMarcacoesPadraoService.previewGeracao(this.entity.apuracaoponto, this.setRequestBody());
    }

    isSubmitDisabled() {
        return this.busy || this.isSelecaoPorTrabalhadorSemItens();
    }

    setRequestBody(): IGeracaoDeMarcacoesPadraoCreate {
        const selecaoPorTrabalhador = this.entity.aba_selecao_colaboradores === 2;

        return {
            datainicial: this.entity.datainicial,
            datafinal: this.entity.datafinal,
            historico: this.entity.historico,
            justificativa: this.entity.historico === null ? this.entity.justificativa : null,
            trabalhadores: selecaoPorTrabalhador ? (this.entity.trabalhadores || []) : [],
            empresa: this.entity.empresa,
            estabelecimento: selecaoPorTrabalhador ? '' : this.entity.estabelecimento,
            departamento_colaboradores: selecaoPorTrabalhador ? null : this.entity.departamento_colaboradores,
            lotacao_colaboradores: selecaoPorTrabalhador ? null : this.entity.lotacao_colaboradores,
            grupo_colaboradores: selecaoPorTrabalhador ? null : this.entity.grupo_colaboradores,
        };
    }

    buildPreviewModalData(): IVisualizacaoPreviaGeracaoModalData {
        const selecaoPorTrabalhador = this.entity.aba_selecao_colaboradores === 2;

        return {
            apuracaoSelecionadaLabel: this.entity.apuracao_selecionada_label_ui || '-',
            periodo: {
                datainicial: this.formatDateLabel(this.entity.datainicial),
                datafinal: this.formatDateLabel(this.entity.datafinal),
            },
            historicoOuJustificativa: this.buildHistoricoOuJustificativaPreview(),
            tipoSelecaoColaboradores: selecaoPorTrabalhador ? 'trabalhador' : 'filtro',
            filtrosAplicados: this.buildFiltrosAplicadosResumo(),
            trabalhadoresSelecionados: this.buildTrabalhadoresSelecionadosPreview(),
        };
    }

    buildFiltrosAplicadosResumo() {
        return {
            estabelecimentoLabel: this.entity.estabelecimento_selecionado_ui?.nomefantasia || 'Todos',
            departamentoLabel: this.entity.departamento_colaboradores_selecionado_ui?.nome || 'Todos',
            lotacaoLabel: this.entity.lotacao_colaboradores_selecionada_ui?.nome || 'Todos',
            grupoPontoLabel: this.entity.grupo_colaboradores_selecionado_ui?.nome || this.entity.grupo_colaboradores_selecionado_ui?.descricao || 'Todos',
        };
    }

    formatDateLabel(date?: string) {
        return date ? moment(date).format('DD/MM/YYYY') : '';
    }

    private buildHistoricoOuJustificativaPreview() {
        if (this.entity.historico !== null) {
            return {
                titulo: 'Histórico',
                valor: this.entity.historico_selecionado_label_ui || '-',
            };
        }

        return {
            titulo: 'Justificativa',
            valor: this.entity.justificativa || '-',
        };
    }

    private getErrorMessage(error: any) {
        return error?.data?.message || error?.data?.mensagem || error?.data?.erro || undefined;
    }

    private isSelecaoPorTrabalhadorSemItens() {
        return this.entity.aba_selecao_colaboradores === 2 && !this.entity.trabalhadores?.length;
    }

    private buildTrabalhadoresSelecionadosPreview(): IVisualizacaoPreviaGeracaoModalTrabalhadorSelecionado[] {
        return angular.copy(this.entity.trabalhadores_selecionados_ui || []);
    }
}
